import { hasUnitAccess, isSuperUser, OPPPermissions } from "@pdpp/lib-planta";
import { userPermissions$ } from "../state/permissions";
import { selectedUnitMeta$ } from "../state/unitMeta";
import { OPP_AUTHZ } from "./runtimeConfig";
export function canEditForecast() {
    if (!OPP_AUTHZ) {
        return true;
    }
    const userPermissions = userPermissions$.value;
    if (userPermissions?.permissions?.includes(OPPPermissions.FORECAST_WRITE) !==
        true) {
        return false;
    }
    if (isSuperUser(userPermissions.roles)) {
        return true;
    }
    const unitMeta = selectedUnitMeta$.value;
    if (!unitMeta) {
        return false;
    }
    return hasUnitAccess(userPermissions.orgs ?? [], unitMeta.extId, unitMeta.extType, unitMeta.countryCode);
}
//# sourceMappingURL=permissions.js.map